import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// App version - update this when deploying new versions
const APP_VERSION = '2.1.0';
const VERSION_KEY = 'app_version';

// Check if version changed and clear cache if needed
const checkAndClearCache = () => {
  const storedVersion = localStorage.getItem(VERSION_KEY);
  
  if (storedVersion !== APP_VERSION) {
    console.log(`App updated from ${storedVersion || 'unknown'} to ${APP_VERSION}. Clearing cache...`);
    
    // Clear localStorage except for essential items
    const essentialKeys = ['auth_token', 'cookieConsent'];
    const keysToRemove = [];
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!essentialKeys.includes(key)) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    // Clear sessionStorage completely
    sessionStorage.clear();
    
    // Store new version
    localStorage.setItem(VERSION_KEY, APP_VERSION);
    
    // Force reload to clear any in-memory cache
    if (storedVersion) {
      window.location.reload(true);
    }
  }
};

// Run cache check before rendering
checkAndClearCache();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
